<template>
  <div class="card_complex_indicator">
    <div class="complex_indicator_title">
      <span class="">{{ data.title }}</span>
    </div>

    <div
      v-for="(item, i) in estructura"
      style="flex-direction: row; display: flex;"
      :key="i"
    >
      <span v-if="item.etiqueta" :style="`flex-grow: 1; ${makeCSS(item)}`">
        {{ item.etiqueta }}:
      </span>

      <span
        :style="
          `
              flex-grow: 1; margin-left: 5px;
              ${makeCSS(data[item.expresion]) || makeCSS(item)}`
        "
      >
        {{ value(item)(data) }}
      </span>
    </div>

    <div class="complex_indicator_grafic">
      <router-link
        v-for="(m, i) in data.subGrafica"
        :to="{
          name: 'AnalyticsChart',
          params: { ...m, goBack }
        }"
        
        :key="i"
      >
        {{ m.label }}
      </router-link>
    </div>
  </div>
</template>

<script>
import {makeCSS, formaters} from '../utils';

export default {
  name: "CardNumIndicator",
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    estructura: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    goBack() {
      return this.$route?.params;
    }
  },
  methods: {
    makeCSS(v) {
      return makeCSS(v);
    },
    value(item) {
      return m =>
        m[item.expresion]
          ? `${this.formaters(item)(m[item.expresion], item?.style)}${
              item?.style?.sufijo ? ` ${item?.style?.sufijo}` : ""
            }`
          : " ";
    },
    formaters(item) {
      return formaters(item?.style?.tipo)
    }
  }
};
</script>

<style lang="scss" scoped>
.card_complex_indicator {
  background-color: #fb8e2c;
  border-radius: 16px;
  padding: 8px;
  min-height: 153px;
  min-width: 150px;
  margin: 0 5px;
  margin-top: 16px;
  margin-bottom: 8px;
  text-align: 'center';
}
.complex_indicator_title {
  flex-grow: 1px;
  font-size: 30px;
  text-align: center;
  margin: 0 10px;
  color: #fff;
  font-weight: bold;
  margin-bottom: 5px;
}
.complex_indicator_grafic {
  color: #3399ff;
  text-align: center;
  padding: 5px;
  font-weight: bold;
  text-decoration-line: underline;
  display: flex;
  flex-direction: column;

  a{
    //&:is(:visited,:active){
      color: unset;
    //}
  }
}
</style>
